'use client'

import * as React from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'
import Image from '@/components/image/Image'

interface Props {
  images: string[]
}

const Divider: React.FC<Props> = ({ images }) => {
  const [emblaRef] = useEmblaCarousel({ loop: true }, [
    Autoplay({
      delay: 4000,
      stopOnInteraction: false,
      stopOnFocusIn: false,
    }),
  ])

  return (
    <section className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {images.map((image, index) => (
            <div className="embla__slide" key={index}>
              <div className="embla__slide__image">
                <Image src={image} alt={`Karusell bild ${index}`} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Divider
